import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { registerGuard } from './router-guard'
import IdentityCallback from '@/views/authentication/IdentityCallback.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/clients',
    },
    {
      path: '/clients',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'clients',
          meta: {
            title: 'Clients',
          },
          component: () => import('@/views/clients/ClientsView.vue'),
        },
        {
          path: ':id',
          name: 'client',
          component: () => import('@/layouts/ClientLayout.vue'),
          redirect: { name: 'client-profile' },
          children: [
            {
              path: 'profile',
              name: 'client-profile',
              meta: {
                title: 'Profile',
              },
              component: () => import('@/views/clients/ClientProfileView.vue'),
            },
            {
              path: 'policies',
              name: 'client-policies',
              meta: {
                title: 'Client Policies',
              },
              component: () => import('@/views/clients/ClientPoliciesView.vue'),
            },
            {
              path: 'portals',
              name: 'client-portals',
              meta: {
                title: 'Client Portals',
              },
              component: () => import('@/views/clients/ClientPortalsView.vue'),
            },
            {
              path: 'users',
              name: 'client-users',
              meta: {
                title: 'Client Users',
              },
              component: () => import('@/views/clients/ClientUsersView.vue'),
            },
            {
              path: 'partners',
              name: 'client-partners',
              meta: {
                title: 'Client Partners',
              },
              component: () => import('@/views/clients/ClientPartnersView.vue'),
            },
            {
              path: 'retention',
              name: 'client-retention',
              meta: {
                title: 'Client Retention',
              },
              component: () =>
                import('@/views/clients/ClientRetentionView.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/policies',
      component: DefaultLayout,
      children: [
        {
          path: ':id',
          name: 'policy',
          component: () => import('@/layouts/PolicyLayout.vue'),
          redirect: { name: 'policy-details' },
          children: [
            {
              path: 'details',
              name: 'policy-details',
              meta: {
                title: 'Policy Details',
              },
              component: () => import('@/views/policies/PolicyDetailsView.vue'),
            },
            {
              path: 'delivery-numbers',
              name: 'policy-delivery-numbers',
              meta: {
                title: 'Policy Delivery Numbers',
              },
              component: () =>
                import('@/views/policies/PolicyDeliveryNumbersView.vue'),
            },
            {
              path: 'questions',
              name: 'policy-questions',
              meta: {
                title: 'Policy Questions',
              },
              component: () =>
                import('@/views/policies/PolicyQuestionsView.vue'),
            },
          ],
        },
      ],
    },
    {
      path: '/repudiation-reasons',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'repudiation-reasons',
          meta: {
            title: 'Repudiation Reasons',
          },
          component: () =>
            import('@/views/repudiation-reasons/RepudiationReasonsView.vue'),
        },
        {
          path: ':id',
          name: 'repudiation-reason',
          component: () => import('@/layouts/RepudiationReasonLayout.vue'),
          redirect: { name: 'repudiation-reason-details' },
          children: [
            {
              path: 'details',
              name: 'repudiation-reason-details',
              meta: {
                title: 'Repudiation Reason Details',
              },
              component: () =>
                import(
                  '@/views/repudiation-reasons/RepudiationReasonDetailsView.vue'
                ),
            },
            {
              path: 'usage',
              name: 'repudiation-reason-usage',
              meta: {
                title: 'Repudiation Reason Usage',
              },
              component: () =>
                import(
                  '@/views/repudiation-reasons/RepudiationReasonUsageView.vue'
                ),
            },
          ],
        },
      ],
    },
    {
      path: '/retention',
      component: DefaultLayout,
      children: [
        {
          path: '',
          name: 'retention',
          meta: {
            title: 'Default Retention',
          },
          component: () => import('@/views/retention/RetentionView.vue'),
        },
      ],
    },
    {
      path: '/identity/callback',
      component: AuthLayout,
      children: [
        {
          path: '',
          name: 'identityCallback',
          component: IdentityCallback,
        },
      ],
    },
    {
      path: '/signin/error',
      name: 'signinError',
      component: () => import('@/views/authentication/SigninError.vue'),
      meta: {
        title: 'Signin Error',
        allowAnonymous: true,
      },
    },
  ],
})

registerGuard(router)

export default router
